<template>
  <div class="container">
    <div id="title-of-save">
      <h1 id="title-text-child" class="h1">
        Unicode Detector
      </h1>
    </div>
    <p>
      Determine the encoding of your text which will be used to send it via SMS.
      Depending on the characters in your text, it will be either GSM or unicode.
      GSM allows more characters to be sent and therefore requires fewer message parts for long texts.
      This results in lower cost.
      <sdx-menu-flyout>
        <sdx-menu-flyout-toggle>
          <sdx-icon
              icon-name="icon-information-circle"
              data-testid="infoUD"
              sr-hint="Read more"
          />
        </sdx-menu-flyout-toggle>
        <sdx-menu-flyout-content style="width: 300px" class="sdx-menu-img">
          <span>
            For more info see <a href="https://en.wikipedia.org/wiki/GSM_03.38">GSM_03.38</a>
          </span>
        </sdx-menu-flyout-content>

      </sdx-menu-flyout>
    </p>
    <br/>
    <div class="row">
      <div className="col margin-bottom-2">
        <sdx-input
            name="unicodeDetector"
            data-testid="unicodeDetectorTextarea"
            label="Message"
            type="textarea"
            class="sdx-input sdx-input-textarea"
            placeholder="type or paste your SMS message here"
            v-model="smsMessage"
            @input="(event) => loadSmsSplitDetails(event)"
        ></sdx-input>
      </div>
    </div>
    <sdx-loading-spinner id="spinner-unicodeDetector" ref="spinnerUnicodeDetector" size="large"
                         sr-hint="Loading. Pleas wait."></sdx-loading-spinner>
    <div id="messageOutPut" ref="messageOutPut" v-if="showSmsOutput">
      <div v-for="part in parts" :key="part">
        <div class="col-lg"
             :style="{ border: '1px solid black', borderColor: '--sdx-color-int-green', borderRadius: '10px',  display: 'flex', flexWrap: 'wrap' }">
          <div style="margin: 2px" v-for="char in part" :key="char" :class="'encodingChar '+ char.encoding">
            <div class="centered-content">
              {{ hexCodeToChar(char.hexCode) }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <br/>
    <div class="row">
      <div class="col-lg-4">
        <h6>Message Parts</h6>
        <p v-if="showSmsOutput" class="encodingSummary" data-testid="messageParts">{{ parts.length }}</p>
      </div>
      <div class="col-lg-4">
        <h6>Encoding</h6>
        <p v-if="showSmsOutput" :class="'encodingSummary ' + encoding" data-testid="encoding">{{ encoding }}</p>
      </div>
      <div class="col-lg-4">
        <div>
          <h6>Legend</h6>
          <div class="row">
            <div class="col-lg" style="display: flex; flex-wrap: wrap;">
              <p class="encodingChar GSM"></p>
              <span class="center font font--semi-bold">GSM Character</span>
              <p class="encodingChar UTF16"></p>
              <span class="center font font--semi-bold">Unicode Character</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import unicodeDetectorService from '../service';
import userService from "@/services/user.service";
import loadingSpinnerService from "@/services/loading-spinner.service";
import {showAlert} from "@/services/notification.service";

export default {
  data() {
    return {
      smsMessage: '',
      parts: [],
      encoding: '',
      typingTimer: null,
      showSmsOutput: false,
    }
  },
  mounted() {
    loadingSpinnerService.hideByRef(this.$refs.spinnerUnicodeDetector, this.$refs.messageOutPut);
    userService.initCsrfToken();
  },
  methods: {
    async loadSmsSplitDetails(event) {
      this.smsMessage = event.srcElement.value;
      await this.getSplitsSmsAfterDelay();
    },
    getSplitsSmsAfterDelay() {
      clearTimeout(this.typingTimer);
      this.showSmsOutput = false;
      if (this.showSmsOutput == false && this.smsMessage !== null && this.smsMessage !== '' && this.smsMessage !== undefined) {
        loadingSpinnerService.showByRef(this.$refs.spinnerUnicodeDetector, this.$refs.messageOutPut);
      }
      this.typingTimer = setTimeout(this.getSplitSms, 2000);
    },
    async getSplitSms() {
      try {
        if (this.smsMessage !== null || this.smsMessage !== '' || this.smsMessage !== undefined) {
          let response = await unicodeDetectorService.splitSms(this.smsMessage);
          this.parts = response.data.parts;
          this.encoding = response.data.encoding
          this.showSmsOutput = true;
          loadingSpinnerService.hideByRef(this.$refs.spinnerUnicodeDetector, this.$refs.messageOutPut);
        }
      } catch (error) {
        showAlert(error.message)
      }
    },

    hexCodeToChar(hexCode) {
      const decimalValue = parseInt(hexCode, 16)
      return String.fromCharCode(decimalValue);
    }
  }
}
</script>

<style>
.GSM {
  background-color: #D6D6D6;
}

.UTF16 {
  color: white;
  background-color: #0EABA9;
}

.encodingChar {
  border-radius: 10px;
  padding: 10px;
  width: 6px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.encodingSummary {
  border-radius: 10px;
  padding: 10px;
}

.centered-content {
  text-align: center;
  width: 10px;
  height: 100%;
}

.center {
  padding-top: 10px;
  padding-left: 10px;
  padding-right: 10px;
}
</style>